
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { FunctionalGraphItem } from "./use-get-functional-graph-service";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export async function deleteFunctionalNode(label: string, uuid: string, id: string, token: string): Promise<FunctionalGraphItem & {label: string}> {
  const url = `${config.isometricApiUrl}/functional-graph/${uuid}/${label}/delete-node/${id}`;
  try {
    const response = await apiFetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    return await response.json(); // Parse the JSON response
  } catch (error) {
    console.error("Error:", error); // Handle errors
    throw error;
  }
}

export const useDeleteFunctionalNode = (
  options?: UseMutationOptions<
    any, // API response type
    unknown, // error type
    { label: string; id: string; uuid: string } // variables type
  >
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: { label: string; id: string; uuid: string }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return deleteFunctionalNode(payload.label, payload.uuid, payload.id, token);
    },
    ...options, 
  });
};
